module.exports = __webpack_public_path__ + "assets/img/ninth_user.110fe4c2.png";